import type { Technique } from '../types';
import { SKELETON_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type SkeletonState } from './render';

export const skeleton: Technique<SkeletonState> = {
  id: 'skeleton',
  name: 'Skelettierung',
  category: 'deconstruction',
  description: 'Reduziert die Buchstaben auf ihre Mittelachse und zeichnet sie als Strichzug neu.',
  params: SKELETON_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
